import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AchievementIconPipe } from './pipes/achievement-icon.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule, PipeModule } from '@app/shared';

import { AchievementComponent } from './achievement.component';
import { AccesibilityModule } from '@app/shared/accesibility/accesibility.module';
import { DataTestModule } from '@app/shared/directive/data-test';
import { IconComponent } from '@app/tw-shared/components';
import { AchievementIconTypePipe } from './pipes/achievement-icon-type.pipe';

@NgModule({
    declarations: [AchievementComponent, AchievementIconPipe, AchievementIconTypePipe],
    imports: [CommonModule, InlineSVGModule, TranslateModule, NgbTooltip, PipeModule, LoaderModule, AccesibilityModule, DataTestModule, IconComponent],
    exports: [AchievementComponent, AchievementIconPipe],
})
export class AchievementModule {}
